import raw from "../../rawClients/rawCapiClient";
import routes from "../../capiRoutes";
import attachmentSerializer from "../../serializers/attachment";
export default {
  getOneInProject(projectUid, attachmentUid) {
    return raw.get(routes.attachments.oneInProject(projectUid, attachmentUid));
  },
  getAllInProject(projectUid) {
    return raw
      .getAll(routes.attachments.allInProject(projectUid))
      .then(attachments => attachments.map(attachmentSerializer.fromServer));
  },
};
